import React, { SetStateAction, useCallback } from "react";
import { WidgetSizeT } from "../../localTypes/WidgetSizeT";
import { WASizePreview } from "../../WidgetAdd/WASizePreview/WASizePreview";
import { WidgetScreen } from "../../common/WidgetScreen";
import { WANoteSettings } from "./WANoteSettings";
import { WAFakeHeader } from "../../WidgetAdd/WAFakeHeader";
import { useSizeClass } from "../../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { useIntlTokens } from "../../../../../components/mobile/useIntlTokens";
import { noteWidgetSizes } from "../../WidgetAdd/utils/widgetSizes/noteWidgetSizes";
import { useWidgetNoteMockPreview } from "../../WidgetAdd/Categories/WACategoryNote/getWidgetNoteMockPreview";
import { WANotePreviewTemplate } from "../../WidgetAdd/Categories/WACategoryNote/WANotePreviewTemplate";
import {
  WidgetNoteFontSize,
  WidgetNoteFontStyle,
} from "./__generated__/WANotePreviewQuery.graphql";

export function WANoteComponent(props: {
  template: WANotePreviewTemplate;
  maxSize: WidgetSizeT;
  loading: boolean;
  onCreate: (
    size: WidgetSizeT,
    pages: {
      readonly backgroundColor: string | null;
      readonly currentValue: string;
      readonly fontSize: WidgetNoteFontSize;
      readonly fontStyle: WidgetNoteFontStyle;
      readonly includedInSlideshow: boolean;
      readonly remoteImageURL: string | undefined;
    }[]
  ) => void;
  unitSize: number;
  title: string;
  setTitle(_: SetStateAction<string>): void;
  preview: React.ReactNode;
  dataPrefix: string;
}) {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const intl_tokens = useIntlTokens();

  const mockPreview = useWidgetNoteMockPreview({
    template: props.template,
    dataPrefix: props.dataPrefix,
  });

  const onCreate = useCallback(
    (size: WidgetSizeT) => {
      props.onCreate(
        size,
        mockPreview.note.pages.map((p) => ({
          currentValue: p.currentValue,
          fontSize: p.fontSize,
          fontStyle: p.fontStyle,
          includedInSlideshow: true,
          backgroundColor: p.backgroundColor,
          remoteImageURL: p.image?.largeImage?.url,
        }))
      );
    },
    [mockPreview.note.pages, props]
  );

  return (
    <WidgetScreen
      preview={
        <WASizePreview
          loading={props.loading}
          maxSize={props.maxSize}
          onCreate={onCreate}
          unitSize={props.unitSize}
          widgetSizes={noteWidgetSizes}
        >
          {props.preview}
        </WASizePreview>
      }
      settings={
        <>
          {!isCompact ? <WAFakeHeader title={intl_tokens.SetTitle} /> : null}
          <WANoteSettings title={props.title} setTitle={props.setTitle} />
        </>
      }
    />
  );
}
